import { LayoutSettings } from "@acme/feature";

const Settings = () => {
    return (
        <LayoutSettings />
    )
};

export default Settings;
